import { useCallback, useState } from 'preact/hooks'
import Icon from '@/components/snippets/icon/icon'
import clsx from 'clsx'

export function useGridSelector() {
  const gridOptions = {
    default: { label: 'Default', value: 'default', icon: 'grid-small', cssGridVariables: '--mobile-grid-cols: 2; --desktop-grid-cols: 4;' },
    large: { label: 'Images Only', value: 'large', icon: 'grid-large', cssGridVariables: '--mobile-grid-cols: 4; --desktop-grid-cols: 8;' }
  }
  const [grid, setGrid] = useState(gridOptions.default)
  const [gridSelection, setGridSelection] = useState(Object.keys(gridOptions)[0])
  const cssGridVariables = grid.cssGridVariables

  const gridTailwind = 'scaled-grid'
  const GridIcon = () => <Icon id={gridOptions[gridSelection].icon} className="icon-lg" />

  const handleGridChange = (grid) => {
    setGridSelection(grid)
    setGrid(gridOptions[grid])
  }

  const GridSelector = useCallback(
    ({ buttonClass = 'btn btn-secondary btn-inline group-data-visible:btn-primary', id = 'grid' }) => (
        <x-modal className="relative group data-visible:z-1" data-hide-on-blur data-id={id}>
        <button
          className={buttonClass}
          data-modal-role="toggle"
          data-modal-parent={id}
          aria-label="Toggle Grid View"
          type="button"
        >
          <GridIcon />
          <span className={'text-sm uppercase hidden md:inline-block pr-3'}>Grid</span>
        </button>
        <div
          className="absolute left-0 z-50 flex mt-1 transition-opacity opacity-0 pointer-events-none top-full bg-neutral-medium h-fit w-fit group-data-visible:pointer-events-auto group-data-visible:opacity-100"
        >
          <div className={'flex flex-col'}>
          {Object.keys(gridOptions)?.map((o) => {
            const option = gridOptions[o]
            if (!option) return null
            return (
                <div className="flex items-center">
                    <input
                        id={`grid__${option.value}`}
                        type="radio"
                        value={option.value}
                        name="sort"
                        onClick={() => handleGridChange(option.value)}
                        checked={gridSelection === option.value}
                        className="hidden field-radio"
                    />
                    <label for={`grid__${option.value}`} className={clsx('paragraph-md btn-md gap-1 btn-inline !no-underline px-4 w-full btn whitespace-nowrap hover:bg-brand-yellow-dark', gridSelection === option.value ? 'btn-accent-1' : 'btn-primary-text')}>
                        <Icon id={option.icon} className="icon-md" />
                        {option.label}
                    </label>
                </div>
            )
          })}

          </div>
        </div>
      </x-modal>
    ), [grid])

  return { GridSelector, grid, gridTailwind, cssGridVariables }
}
